export default "__VITE_ASSET__Bv6dWiqs__"